/**
 * Recover an email image's alignment (left / center / right) from saved HTML.
 *
 * The editor serializes an aligned image as a wrapping block:
 *   <div style="text-align:center" data-align="center"><a href><img></a></div>
 *
 * But the save-time sanitizer (crm-api EmailContentScrubber) STRIPS `data-align`
 * (now re-added to the allowlist, but old content lost it) while KEEPING the
 * `style="text-align:…"`. And the <img>'s immediate parent is often the <a>
 * link, not the styled <div>. So:
 *   1. prefer an explicit `data-align` on ANY ancestor wrapper, then
 *   2. fall back to a `text-align` style on a block ancestor — walking a few
 *      levels up (NOT just `parentElement`; that only saw the <a> and was the
 *      bug that made centered images snap back to the left on edit).
 *
 * Pinned by tiptap-image-align.test.ts.
 */
export function parseImageAlign(
  element: HTMLElement,
): "left" | "center" | "right" | null {
  let ta: string | null | undefined = (
    element.closest("[data-align]") as HTMLElement | null
  )?.getAttribute("data-align")

  if (!ta) {
    let node: HTMLElement | null = element.parentElement
    for (let i = 0; node && i < 4 && !ta; i++) {
      const t = node.style?.textAlign
      if (t === "left" || t === "center" || t === "right") ta = t
      node = node.parentElement
    }
  }

  return ta === "left" || ta === "center" || ta === "right" ? ta : null
}
